// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"41ea81cf","484":"da12d49f","551":"df1741c0"}[chunkId] + ".chunk.js";
};